import moment from 'moment';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

export const getStartLimiterFunc = dates => current => {
  const isFutureDate = current && current > moment().endOf('day');
  if (!dates || dates.length === 0) {
    return isFutureDate;
  }
  const isAfterEndDate = dates[1] && current.isAfter(dates[1], 'day');
  const isMoreThan90DaysBeforeEndDate = current && dates[1] && dates[1].diff(current, 'days') > 90;
  return isMoreThan90DaysBeforeEndDate || isFutureDate || isAfterEndDate;
};

export const getEndLimiterFunc = dates => current => {
  const isFutureDate = current && current > moment().endOf('day');
  if (!dates || dates.length === 0) {
    return isFutureDate;
  }
  const isBeforeStartDate = dates[0] && current.isBefore(dates[0], 'day');
  const isMoreThan90DaysBeforeStartDate = current && dates[0] && current.diff(dates[0], 'days') > 90;
  return isFutureDate || isMoreThan90DaysBeforeStartDate || isBeforeStartDate;
};

export const getDisabledDatesForSecondPickerFunc = datesFirstPicker => current => {
  if (!current || isEmpty(datesFirstPicker)) return false;
  const today = moment();
  const currentParsed = moment(current?.$d).startOf("day");
  const startDate = get(datesFirstPicker, '[0]');
  const endDate = get(datesFirstPicker, '[1]') || today;
  const diff = endDate?.diff(startDate, 'days');

  const isWithinRange =
    (current.isSame(startDate, 'date') || current.isAfter(startDate)) &&
    (current.isSame(endDate, 'date') || current.isBefore(endDate));

  const isBeforeStartDate = current.isBefore(startDate) && startDate?.diff(currentParsed, 'days') <= diff;
  const isAfterEndDate = current.isAfter(endDate) && today.diff(currentParsed, 'days') <= diff;
  const isFutureDate = currentParsed.isAfter(today);

  return isWithinRange || isBeforeStartDate || isAfterEndDate || isFutureDate;
};
